/**
 * Created by Mark on 18/04/2017.
 */


import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Row , Col , ProgressBar , Button } from 'react-bootstrap';
import ClassService from '../../../services/classes-service.js';
import GeneratePDF from '../../../classes/pdf_generate.js';
import LanguageSelector from '../../inputs/language-selector.js';
import Toggle from '../../inputs/input.toggle.component.js';
import { Link , hashHistory } from "react-router";
import ClassStore from '../../../store/classes-store.js';

class ReviewStudents extends React.Component {

    constructor(props) {
        super(props);
        this.state = { saved: false, classInformation:undefined};
        this.uid = null;
        this.PDFgen = new GeneratePDF();
    }

    componentDidMount() {

        ClassService.createNewClass(this.props.data.name , this.props.data.students  , this.props.data.allLanguages , this.props.data.selectedlanguages , this.props.data.sharedTeachers).then(function(uid){
            this.uid = uid;
            ClassService.getClass(this.uid);
            this.setState({saved:true});
        }.bind(this));
    }

    componentWillMount(){

        ClassStore.on("UPDATE_CLASS" , () => {
            this.setState({classInformation:ClassStore.class});
        });

    }

    renderOptions() {

        var gotoClass = React.createElement(Button, {
            onClick: this.gotoClass.bind(this),
            bsStyle: 'primary',
            className: "btn-block",
            smHidden: true
        }, <FormattedMessage id="ui-320" defaultMessage="Goto Class" />);

        var downloadLogins = React.createElement(Button, {
            onClick: this.downloadLogins.bind(this),
            bsStyle: 'primary',
            className: "btn-block",
            smHidden: true
        }, <FormattedMessage id="ui-2128" defaultMessage="Download Student Logins" />);

        return (
            <div>
                <Row>
                    <Col sm={6}>{gotoClass}</Col>
                    <Col sm={6}>{downloadLogins}</Col>
                </Row>
            </div>
        )
    }

    renderLoadingOptions() {

        var gotoClass = React.createElement(Button, {
            onClick: this.gotoClass.bind(this),
            bsStyle: 'primary',
            className: "btn-block",
            smHidden: true
        }, <FormattedMessage id="ui-320" defaultMessage="Goto Class" />);

        var downloadLogins = React.createElement(Button, {
            onClick: function(){},
            bsStyle: 'primary',
            className: "btn-block",
            smHidden: true
        },<div> <i className='Select-loading'></i> <FormattedMessage id="ui-2128" defaultMessage="Download Student Logins" /></div>);

        return (
            <div>
                <Row>
                    <Col sm={6}>{gotoClass}</Col>
                    <Col sm={6}>{downloadLogins}</Col>
                </Row>
            </div>
        )
    }

    gotoClass(){
        if (this.uid != null){
            hashHistory.push('class/profile/'+this.uid+'/2');
        }
    }

    downloadLogins(){
        if (this.state.classInformation != undefined){
            this.PDFgen.generateClassPDF(this.state.classInformation.name, this.state.classInformation.students);
        }

    }

    render(){
        if (this.state.saved == true) {
            return this.renderOptions();
        } else {
            return this.renderLoadingOptions();
        }
    }
}


export default {
    name: <FormattedMessage id={ 'ui-336' } defaultMessage={ 'Save' }/>,
    onSubmit: function (done){
        done();
    },
    component: ReviewStudents
}


// WEBPACK FOOTER //
// ./src/components/wizard/create-class-steps/save-class.js